<template>
  <div class="card" :class="{disabledcard : obj.full}">
    <header class="card-header">
      <p class="card-header-title">
        {{obj.time}} </p>
      <div class="card-header-title">
        <span class="tag is-rounded is-outlined is-medium">{{obj.duration}} minutes </span>
      </div>
      <div class="card-header-icon">
        <button v-if="obj.full" class="button" disabled> Closed </button>
        <button v-else class="button is-danger" @click="cardModal()"> Reserve </button>
      </div>
    </header>
    <div class="card-content">
      <div class="media" style="align-items:center">
        <div class="media-left">
          <figure class="image is-64x64" >
            <img :src="obj.pic" alt="Placeholder image" style="border-radius:100%">
          </figure>
        </div>
        <div class="media-content ">
          <p class="title is-5">{{obj.title}}</p>
          <p class="subtitle is-6" style="margin-bottom:10px;">with {{obj.trainer}}</p>
          <span class="tag is-rounded is-small" >{{obj.nbr_rounds}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Form from './FormAsync.vue'
  export default {
    name: 'Schedule',
    components: {
      Form
    },
    props: [
      'obj', 'date','table','content'
    ],
    data: function () {
      return {}
    },
    methods: {
      cardModal() {
        window.fbq('track', 'Search');
        this.$modal.open({
          parent: this,
          component: Form,
          hasModalCard: true,
          props: {
            "obj": this.obj,
            "date": this.date,
            "workout_id": this.obj.workout_id,
            "content":this.content.form

          },
          canCancel: ['escape', 'outside']
        })
      }

    },
  }
</script>

<style scoped>
  .bottom-content {
    display: flex;
    justify-content: space-between;
  }

  .card-header {
    background-color: #EEE
  }

  .is-outlined {
    border: 1px solid rgb(74, 74, 74);

  }
  .disabledcard {
    background-color: #EEE
  }
</style>